export enum StorageKey {
	InitialMessageExpDt = 'InitialMessage',
}
